import { atom } from "@byko/lib-recoil";

import type { CustomerAccountMembership } from "@byko/lib-api-rest";

export const membershipsState = atom<CustomerAccountMembership[]>({
  key: "memberships",
  default: [],
});
